import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, ButtonStyles} from "../form/Button/Button";
import {getShopId} from "../getShopId";
import Modal from "./Modal";
import {useCustomerSelector} from "../../../store";
import {validateEmail} from "../../../helpers/emailRegExp";

interface IForgotPasswordModalProps {
  closeFunction: () => void;
  isVisible: boolean;
}

const ForgotPasswordModal: React.FC<IForgotPasswordModalProps> = (props) => {
  const {customer} = useCustomerSelector();
  const {t} = useTranslation("checkout");
  const contactPhone = contactPhoneNumbers[getShopId()];

  const EmailSentText: React.FC = () => (
    <React.Fragment>
      <p className="content" style={{margin: "16px 0"}}>
        {t("general.emailToResetPassword")}{" "}
        <a style={{cursor: "pointer", color: "#1BA1E2"}} href={`tel:${contactPhone}`}>
          {contactPhone}
        </a>
      </p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={props.closeFunction}>
          {t("Okay")}
        </Button>
      </div>
    </React.Fragment>
  );

  const EnterEmail: React.FC = () => {
    const [email, setEmail] = useState<string>();
    const [{emailSent, error}, setEmailState] = useState<{emailSent: boolean; error: boolean}>({
      emailSent: false,
      error: false,
    });
    const [validEmail, setValidEmail] = useState<boolean>(true);

    const sendEmail = async (evt: React.FormEvent) => {
      evt.preventDefault();
      try {
        if (email && validateEmail(email)) {
          setValidEmail(true);
          await customer.requestPassword(email);
          setEmailState((prevState) => ({...prevState, emailSent: true}));
        } else {
          setValidEmail(false);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setEmailState((prevState) => ({...prevState, error: true}));
      }
    };

    if (emailSent) {
      return <EmailSentText />;
    }

    return (
      <React.Fragment>
        <p className="content">{t("general.newPasswordRequest")}</p>
        {error && <p style={{color: "red"}}>{t("general.emailNetworkError")}</p>}
        {!validEmail && <span style={{color: "red"}}>{t("form.emailNotValid")}</span>}
        <form style={{margin: "16px 0"}} onSubmit={(evt: React.FormEvent) => sendEmail(evt)}>
          <input
            style={{marginBottom: "16px", display: "block"}}
            type="email"
            placeholder={t("form.yourEmailAddress") + " **"}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
          <Button styles={[ButtonStyles.big]}>{t("general.requestPassword")}</Button>
        </form>
      </React.Fragment>
    );
  };

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{t("general.resetPassword")}</h2>
      <EnterEmail />
    </Modal>
  );
};

export default ForgotPasswordModal;

const contactPhoneNumbers: {[key: number]: string} = {
  100001: "+49-511-93688676",
  100009: "+4312056367189",
  100017: "+41432157892",
  100027: "+41 43 2157892",
  100005: "+18184477206",
  100020: "+442038800027",
  100008: "+33185642360",
  100022: "+4532725247",
  100029: "+31207081554",
};
